var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-expansion-panel",
    [
      _c("v-expansion-panel-header", [_vm._v("Owners")]),
      _c(
        "v-expansion-panel-content",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  staticStyle: { "justify-items": "flex-end" },
                  attrs: { cols: "12" },
                },
                [
                  _c("v-switch", {
                    attrs: {
                      "hide-details": "",
                      color: "orange darken-3",
                      label: "Exclude mode",
                    },
                    model: {
                      value: _vm.model.ownersExclude,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "ownersExclude", $$v)
                      },
                      expression: "model.ownersExclude",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            _vm._l(_vm.owners, function (owner) {
              return _c(
                "v-col",
                { key: `iko${owner}`, attrs: { cols: "12", md: "2", sm: "2" } },
                [
                  _c("v-checkbox", {
                    attrs: { value: owner, label: `${owner}` },
                    model: {
                      value: _vm.model.owners,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "owners", $$v)
                      },
                      expression: "model.owners",
                    },
                  }),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }